/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Box, Typography } from '@mui/material';
import { themes } from '../../themes/themes';
import { DateField } from '../../../components';
import { baseDateFormatting } from '../../helper';

interface PropValue {
  typeName: string;
  actorName: any;
  date1: string;
  date2?: string;
  dayOrAmount: any;
  remarks: string;
  status: string;
}
const LeaveHistoryArTile = ({
  status,
  actorName,
  date1,
  dayOrAmount,
  remarks,
  typeName,
  date2,
}: PropValue) => {
  return (
    <Box
      style={{
        backgroundColor: '#F5F5FA66',
        height: 'auto',
        padding: '1em',
        borderRadius: '10px',
        marginTop: '1em',
      }}
    >
      <Box
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
        }}
      >
        <Typography
          style={{
            fontFamily: 'Lato',
            color: themes.greySubtitle,
            fontSize: '0.8em',
            fontWeight: 'bold',
          }}
        >
          {typeName}
        </Typography>
        <Typography
          style={{
            fontFamily: 'Lato',
            color: themes.greySubtitle,
            fontSize: '0.8em',
            fontWeight: 'bold',
            fontStyle: 'italic',
          }}
        >
          {status}{' '}
          <span style={{ color: themes.defaultScondary_blue }}>
            {actorName}
          </span>
        </Typography>
      </Box>
      <Box
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          marginTop: '0.2em',
        }}
      >
        <Typography
          style={{
            fontFamily: 'Lato',
            color: themes.defaultScondary_blue,
            fontSize: '0.8em',
            fontWeight: 'bold',
          }}
        >
          <DateField value={date1} format={baseDateFormatting} />
          {date2 && (
            <>
              <span style={{ color: themes.grey_colorDesignationAR }}>to</span>{' '}
              <span>
                {' '}
                <DateField value={date2} format={baseDateFormatting} />
              </span>
            </>
          )}
        </Typography>
        <Typography
          style={{
            fontFamily: 'Lato',
            color: themes.defaultScondary_blue,
            fontSize: '0.75em',
            fontWeight: 'bold',
          }}
        >
          {dayOrAmount}
        </Typography>
      </Box>
      <Box
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          marginTop: '0.2em',
        }}
      >
        <Typography
          style={{
            fontFamily: 'Lato',
            color: themes.greySubtitle,
            fontSize: '0.75em',
          }}
        >
          Remark: <span style={{ fontStyle: 'italic' }}>{remarks}</span>
        </Typography>
      </Box>
    </Box>
  );
};

export default LeaveHistoryArTile;
